<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./Certifications.translations.json";
	import { getTenant } from "../contexts/tenantContextKey.js";
	import Icon from "./Icon.svelte";
	import { downloadsPathMap } from "../../../core/schema/paths/downloadsPathMap.js";
	import Link from "./Link.svelte";
	import tuvnord from "../../../core/assets/icons/tuvnord.svg?raw";
	import { DocumentCategory } from "../../../core/schema/DocumentCategory.js";
	import { getPathInLocale } from "../../../core/schema/paths/getPathInLocale.js";
	import { slugify } from "../../../core/utils/slugify.js";

	const translate = getTranslate(translations);
	const { locale } = getTenant();
</script>

<section class="container flex flex-col gap-16 py-14 lg:flex-row">
	<div class="bg-tertiary/90 px-7 py-11 backdrop-blur-md lg:basis-5/12 lg:px-14 lg:py-20">
		<h2 class="mb-14 text-lg font-semibold sm:text-[2.75rem] lg:mb-28 lg:text-4xl">
			{translate("certificationsHeader")}
		</h2>
		<div class="lg:text-2md text-[1.125rem] font-normal lg:font-light">
			<p class="lg:text-2md text-[1.125rem]">{translate("improvementMeans")}</p>
			<ol class="flex list-decimal flex-col gap-8 pl-5">
				<li>{translate("improvement1")}</li>
				<li>{translate("improvement2")}</li>
				<li>{translate("improvement3")}</li>
				<li>{translate("improvement4")}</li>
				<li>{translate("improvement5")}</li>
			</ol>
		</div>
	</div>
	<div class="relative flex flex-col items-end justify-end gap-12 lg:basis-7/12">
		<div class="inset-0 -z-10 place-items-center lg:absolute lg:grid">
			<div class="flex flex-wrap justify-center gap-12 lg:gap-x-20 lg:gap-y-16">
				<Icon icon={tuvnord} class="!aspect-auto h-8" />
				<Icon icon={tuvnord} class="!aspect-auto h-8" />
				<Icon icon={tuvnord} class="!aspect-auto h-8" />
				<Icon icon={tuvnord} class="!aspect-auto h-8" />
				<Icon icon={tuvnord} class="!aspect-auto h-8" />
			</div>
		</div>
		<Link
			asButton
			href="/{getPathInLocale(locale, downloadsPathMap)}#{slugify(DocumentCategory.Certification)}"
			containerClass="lg:!w-fit"
			class="max-lg:!w-full max-lg:!max-w-full"
		>
			{translate("downloadCertificates")}
		</Link>
	</div>
</section>
